import React from 'react'
import { FooterLogoSec } from '../HeaderAndfooter/FooterLogoSec';
import { FooterUsefullLinksColm } from '../HeaderAndfooter/FooterUsefullLinksColm';
import { FooterFollowUs } from '../HeaderAndfooter/FooterFollowUs';
import { FooterBackToTop } from '../HeaderAndfooter/FooterBackToTop';
import logo from '../assets/images/logo.png'


export default function Footer() {
  return (
    <footer id='footer'>
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6"><FooterLogoSec /></div>
            <div className="col-lg-3 col-md-6"><FooterUsefullLinksColm /></div>
            <div className="col-lg-3 col-md-6"><FooterFollowUs /></div>
            <div className="col-lg-3 col-md-6"><FooterBackToTop /></div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center" style={{textAlign:"center", justifyContent:"center"}}>
            {/* <div className="col-md-6">
              <p className="copyright">© {new Date().getFullYear()} Epic Texas Charters. All rights reserved.</p>
            </div> */}
            <div className="col-md-6 text-md-right">
           <p className="credit">© 2025. All rights reserved.<span className='dandd'> Designed & Developed by</span> <a href='https://apexcreativedesigns.com/'>   <img src={logo}  style={{width: "127px", padding:"0px 0px 8px"}}/> </a> </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
